/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IVisitable } from '../../core/models/IVisitable';
import { AaiTraitType } from './AaiTraitType';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IAaiTrait extends IVisitable {
    getTraitType() : AaiTraitType;
}


